export default {
  headerContent: {
    title: 'Türkiye Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Türkiye Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Türkiye Sigorta kasko sigortası ile aracınız yanma, çalınma, çarpılma ve çalınma riskleri başta olmak üzere birçok riske karşı güvence altındadır.',
        'İdeal araç sigortası kapsamı, ihtiyaçlarınıza ve sürüş geçmişinize bağlı olarak değişecektir. ',
        'Araba sigortası için beklenen ödemenizin ne kadar olabileceğine dair küçük bir tahmin elde etmek için hesaplama aracımızı kullanabilirsiniz. Sigorta için ne kadar harcamanız gerektiği, hangi teminatlara ihtiyacınız olduğuna, nerede yaşadığınıza ve sürüş geçmişinize bağlıdır.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Araç Kasko Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Kasko sigortası isteğe bağlı bir sigorta ürünüdür. Aracınızı ve bütçenizi güvence altına almak için Türkiye Sigorta’nın ürününü değerlendirebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Doğru miktarda otomobil sigortası kapsamı, ihtiyaçlarınıza, bütçenize ve bölge gereksinimlerinize bağlıdır. Doğru sigortaya sahip olduğunuzdan emin olmak için teminatları ve limitleri karşılaştırmanız gerekir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Türkiye Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Araç sigorta poliçeniz, aracınızın dâhil olduğu farklı durumlarda koruma sağlayan birden fazla teminattan oluşur. Teminatların farklı limitleri vardır.',
          subList: [
            'Anahtar kaybı neticesinde aracın çalınması',
            'Anahtar kaybı neticesinde kilit mekanizmasının değiştirilmesi',
            'Çalınma',
            'Çarpma ve çarpışma',
            'Deprem, toprak kayması, fırtına, dolu, yıldırım veya yanardağ püskürmesi nedeniyle meydana gelen zararlar',
            'Eskime payı',
            'Ferdi kaza acil yardım teminatı',
            'Ferdi kaza koltuk',
            'Ferdi kaza koltuk deprem teminatı',
            'Ferdi kaza koltuk ölüm ve sürekli sakatlık teminatı',
            'Grev, lokavt, halk hareketleri, terör',
            'Hasarsızlık koruma',
            'Hukuksal koruma',
            'İhtiyari mali sorumluluk',
            'İhtiyari mali sorumluluk manevi tazminat talepleri',
            'İş durması',
            'Kasa teminatı',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Mini onarım',
            'Motorlu araca bağlı hukuksal koruma',
            'Özel eşya teminatı',
            'Patlayıcı ve parlayıcı madde taşınması',
            'Sel ve su baskını',
            'Ses ve görüntü cihazları',
            'Sürücü hukuksal koruma',
            'Taşınan yük',
            'Taşıtta sigara ve benzeri maddelerin teması ile meydana gelen yangın dışındaki zararlar',
            'Yanlış akaryakıt dolumu',
            'Yanma',
            'Yetkili olmayan kişilere çektirme, çekme',
            'Yurt dışında meydana gelen zararları içerir.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Sigortası Teminat Dışı Haller Nelerdir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Sürücü belgesi olmayan veya yetersiz olan kişilerin aracı kullanmasından dolayı oluşan hasarlar',
            'Alkol veya uyuşturucu kullanımı sonrasında oluşan hasarlar',
            'Aracın orijinalliğini bozacak şekilde sonradan yapılan eklemelerden kaynaklı hasarlar',
            'Sigortalının kasti olarak oluşturacağı hasarlar teminatı dışı bırakılmıştır. '
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Mini Onarım Teminatı Nedir?',
      content: [
        {
          paragraph:
            'Mini onarım teminatı aracınızda küçük çaplı onarım gerektiren hasarları poliçenizi bozmadan RS servislerinde poliçe limitlerinize kadar yaptırmanıza olanak sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Mini Onarım Teminatı Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Mini onarım hizmeti aracınızda oluşan küçük çaplı hasarları güvence altına almaktadır.',
          subList: [
            'Boya Hasarlı Kaporta Göçük Düzeltme',
            'Boya Onarımı, Mini Yama',
            'Boyasız Kaporta Göçük Düzeltme',
            'İç Döşeme Onarımı',
            'Leke Çıkarma',
            'Ön Cam Onarımı',
            'Plastik Tampon ve Parça Onarımı'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Araba sigortası sizi mali kayıplara karşı korur, ancak koruma seviyesi seçtiğiniz poliçe türüne bağlıdır. Türkiye Sigorta müşterilerine 4 adet farklı ürün sunmaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong>Bu ürünler;</strong>',
          subList: [
            'Genişletilmiş Kasko Sigortası',
            'Dost Kasko Sigortası',
            'Fiat Kasko Sigortası',
            'Muafiyetli Kasko Sigortasıdır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Genişletilmiş Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Araç kasko sigortası ile aracınızı geniş teminatlar ile koruma altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Poliçe süresi içerisinde meydana gelen bir arıza veya kaza sonucu Sigortalı Araçta oluşan (Kasko Poliçe kapsamında) bir hasar sonucunda ve gerekli tüm koşulların sağlanması halinde, Poliçede yazılı koşullar ve limitler çerçevesinde (en fazla yılda 2 defa) Sigortalı/sigorta ettiren Kişiye ikame kiralık araç verilir. İkame araç hizmet sadece özel oto ve seçimli olarak hususi kullanımlı kamyonetler ile hafif ticari kamyonetlere verilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Dost Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Anahtar kaybı neticesinde aracın çalınması',
            'Anahtar kaybı neticesinde kilit mekanizmasının değiştirilmesi',
            'Çalınma',
            'Çarpma ve çarpışma',
            'Deprem, toprak kayması, fırtına, dolu, yıldırım veya yanardağ püskürmesi nedeniyle meydana gelen zararlar',
            'Eskime payı',
            'Ferdi kaza acil yardım teminatı',
            'Ferdi kaza koltuk',
            'Ferdi kaza koltuk deprem teminatı',
            'Ferdi kaza koltuk ölüm ve sürekli sakatlık teminatı',
            'Grev, lokavt, halk hareketleri, terör',
            'Hasarsızlık koruma',
            'Hukuksal koruma',
            'İhtiyari mali sorumluluk',
            'İhtiyari mali sorumluluk manevi tazminat talepleri',
            'İş durması',
            'Kasa teminatı',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Mini onarım',
            'Motorlu araca bağlı hukuksal koruma',
            'Özel eşya teminatı',
            'Patlayıcı ve parlayıcı madde taşınması',
            'Sel ve su baskını',
            'Ses ve görüntü cihazları',
            'Sürücü hukuksal koruma',
            'Taşınan yük',
            'Taşıtta sigara ve benzeri maddelerin teması ile meydana gelen yangın dışındaki zararlar',
            'Yanlış akaryakıt dolumu',
            'Yanma',
            'Yetkili olmayan kişilere çektirme, çekme',
            'Yurt dışında meydana gelen zararlar güvence kapsamındadır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Fiat Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sadece Fiat veya Tofaş – Fiat marka araçlar sahiplerinin yaptırabildiği kasko sigortası ürünüdür. Bu sigorta ile yetkili servislerde ayrıcalıklı hizmetlerden yararlanabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Fiat Kasko Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Yanma',
            'Çalınma',
            'Çarpma ve çarpışma',
            'Grev, lokavt, halk hareketleri, terör',
            'Sel ve su baskını',
            'Anahtar kaybı neticesinde aracın çalınması',
            'Taşıtta sigara ve benzeri maddelerin teması ile meydana gelen yangın dışındaki zararlar',
            'Yetkili olmayan kişilere çektirme, çekme',
            'Patlayıcı ve parlayıcı madde taşınması',
            'Kasa teminatı',
            'Taşınan yük',
            'Eskime payı',
            'Yanlış akaryakıt dolumu',
            'Hasarsızlık koruma',
            'İş durması',
            'Deprem, toprak kayması, fırtına, dolu, yıldırım veya yanardağ püskürmesi nedeniyle meydana gelen zararlar',
            'Mini onarım',
            'Anahtar kaybı neticesinde kilit mekanizmasının değiştirilmesi',
            'Özel eşya teminatı',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Ses ve görüntü cihazları',
            'Yurt dışında meydana gelen zararlar',
            'İhtiyari mali sorumluluk',
            'İhtiyari mali sorumluluk manevi tazminat talepleri',
            'Ferdi kaza koltuk',
            'Ferdi kaza koltuk ölüm ve sürekli sakatlık teminatı',
            'Ferdi kaza acil yardım teminatı',
            'Ferdi kaza koltuk deprem teminatı',
            'Hukuksal koruma',
            'Motorlu araca bağlı hukuksal koruma',
            'Sürücü hukuksal koruma teminatı yer alır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Muafiyetli Kasko Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Muafiyetli kasko sigortası, 2500 TL üzerindeki hasarlarınıza koruma sağlayan kasko sigortasıdır. Diğer sigorta ürünlerine göre primi daha uygundur.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Muafiyetli Kasko Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Anahtar kaybı neticesinde aracın çalınması',
            'Anahtar kaybı neticesinde kilit mekanizmasının değiştirilmesi',
            'Çalınma',
            'Çarpma ve çarpışma',
            'Deprem, toprak kayması, fırtına, dolu, yıldırım veya yanardağ püskürmesi nedeniyle meydana gelen zararlar',
            'Eskime payı',
            'Ferdi kaza acil yardım teminatı',
            'Ferdi kaza koltuk',
            'Ferdi kaza koltuk deprem teminatı',
            'Ferdi kaza koltuk ölüm ve sürekli sakatlık teminatı',
            'Grev, lokavt, halk hareketleri, terör',
            'Hasarsızlık koruma',
            'Hukuksal koruma',
            'İhtiyari mali sorumluluk',
            'İhtiyari mali sorumluluk manevi tazminat talepleri',
            'İş durması',
            'Kasa teminatı',
            'Kemirgen ve diğer hayvanların vereceği zararlar',
            'Mini onarım',
            'Motorlu araca bağlı hukuksal koruma',
            'Özel eşya teminatı',
            'Patlayıcı ve parlayıcı madde taşınması',
            'Sel ve su baskını',
            'Ses ve görüntü cihazları',
            'Sürücü hukuksal koruma',
            'Taşınan yük',
            'Taşıtta sigara ve benzeri maddelerin teması ile meydana gelen yangın dışındaki zararlar',
            'Yanlış akaryakıt dolumu',
            'Yanma',
            'Yetkili olmayan kişilere çektirme, çekme',
            'Yurt dışında meydana gelen zararlar güvence kapsamındadır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Yaş Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta 15 yaş ve altı araçlara kasko sigortası düzenlemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Hasarsızlık İndirimi Ne Kadar Geçerli?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta 6 aya kadar hasarsızlık indiriminiz kullanabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: ' Türkiye Sigorta Kasko Bozulursa Ne Kadar Artar?',
      content: [
        {
          paragraph:
            'Kasko artışı yapmış olduğunuz kaza adedi ve bedellerine göre değişmektedir. Net bir artış söylenememektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ağır Hasarlı Araca Kasko Yapılır Mı?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta risk kabul kriterleri gereğince ağır hasarlı araca kasko yapmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Kasko Fiyatını Nasıl Öğrenebilirim?',
      content: [
        {
          paragraph:
            'Kasko teklifleri her birey için farklılık gösterdiğinden, oranları karşılaştırmak genellikle araba sigortasında tasarruf sağlamanın en iyi yoludur. Size en uygun oranı bulmak için her zaman birden fazla otomobil sigortacısı planının teklifini almanızı öneririz. ',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com ile en doğru fiyat teklifini alın veya sizin için ortalama araba sigortası maliyetlerinin ne kadar düştüğünü online öğrenin.',
          subList: null
        },
        {
          paragraph:
            'Kasko sigortası fiyatınızı öğrenmek için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmalarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Tahmini Kasko Fiyatları Neye Göre Hesaplanır?',
      content: [
        {
          paragraph:
            'Araç sigortası maliyetleri, araç markasına ve modeline göre farklılık gösterebilir. Kasko sigortası fiyatları araç bedeli, sigortalı geçmiş hasar skoru ve talep edilen teminatlara göre hesaplanmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Otomobil sigortası teklifleri, bireysel derecelendirme faktörlerine göre büyük ölçüde değişir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Online Kasko Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Sizin için en uygun kasko sigortası için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Bu işlemler sonucu Alokasko uzman ekibi sizin için en uygun teklifi hazırlayıp sunacaktır.',
          subList: null
        }
      ]
    }
  ]
}
